@if (useSplitter) {
    <p-splitter
        styleClass="splitter-horizontal splitter"
        [layout]="layout"
        [panelSizes]="[workPanelSize, splittedPanelSize]"
        [minSizes]="[30, 0]"
        (onResizeEnd)="onResize($event)"
    >
        <!-- Form -->
        <ng-template pTemplate="form-template">
            <div class="splitter-content-section">
                <ng-container *ngTemplateOutlet="workForm"></ng-container>
            </div>
        </ng-template>

        <!-- Inner vertical splitter -->
        <ng-template pTemplate="splitter-template">
            <p-splitter
                styleClass="splitter"
                layout="vertical"
                [panelSizes]="[35, 65]"
                [minSizes]="[5, 5]"
            >
                <!-- Work card -->
                <ng-template pTemplate="work-card-template">
                    <div class="splitter-content-section">
                        <app-button
                            class="close-splitted-btn"
                            [outlined]="true"
                            size="small"
                            icon="pi-times"
                            (clickEvent)="closeSplittedPanel()"
                        ></app-button>

                        @if (existingWork()) {
                            <app-work-card
                                [work]="existingWork()"
                                [inSplitter]="true"
                                (copyTextToForm)="copyTextToForm($event)"
                                (copyTextToField)="copyTextToFormField($event)"
                                (copyWorkDataToForm)="copyWorkDataToForm()">
                            </app-work-card>
                        }
                    </div>
                </ng-template>

                <!-- Widgets -->
                <ng-template pTemplate="widgets-template">
                    <div class="splitter-content-section">
                        <ng-container *ngTemplateOutlet="widgets"></ng-container>
                    </div>
                </ng-template>
            </p-splitter>
        </ng-template>
    </p-splitter>
} @else {
    <ng-container *ngTemplateOutlet="workForm"></ng-container>
}

<!-- Work form -->
<ng-template #workForm>
    <!-- Work form -->
    @if (folderTerminated()) {
        <app-warn-float-message
            message="folder.archive.readOnly"
            [messageParams]="{ date: (folderClosedAt() | shortDate) }"
        ></app-warn-float-message>
    } @else if (existingWork()?.isBilled) {
        <app-warn-float-message message="workData.common.messages.cannotEditDueToBilled"></app-warn-float-message>
    }

    <!-- Form -->
    <ng-content select="[work-form-select]">
    </ng-content>

    <!-- Widgets (display if doesn't use splitter) -->
    @if (!useSplitter) {
        <ng-container *ngTemplateOutlet="widgets"></ng-container>
    }

    <!-- Buttons -->
    <div class="buttons-wrapper">
        @if (form()?.getRawValue()?.personId > 0) {
            <app-action-buttons
                [primaryButtonVisibility]="form()?.enabled ?? true"
                [primaryButtonDisability]="disableSaveButton()"
                (primaryClickEvent)="submit.emit()"
                (secondaryClickEvent)="close()">
            </app-action-buttons>
        }
    </div>
</ng-template>

<!-- Widgets -->
<ng-template #widgets>
    <ng-content select="[widgets-select]">
    </ng-content>
</ng-template>
